<template>
  <div>
    <Header />

    <form-wizard
      next-button-text="Siguiente"
      back-button-text="Atrás"
      finish-button-text="Comprar"
      title="FINALIZA TU COMPRA"
      subtitle="Realiza tu compra fácil y simple"
      color="#009db0"
      @on-complete="onComplete"
    >
      <tab-content title="Datos">
        <div class="container">
          <b-form-group class="sale-input" label="Origen:" label-for="input-6">
            <b-form-select
              id="input-6"
              v-model="sale.origin"
              :options="getOrigins()"
              required
            ></b-form-select>
          </b-form-group>

          <b-form-group
            class="sale-input"
            label="Nombre del cliente:"
            label-for="input-8"
          >
            <b-form-input
              id="input-8"
              v-model="sale.customerName"
              type="text"
              placeholder="Ingrese el nombre del cliente"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="sale-input"
            label="Teléfono del cliente:"
            label-for="input-9"
          >
            <b-form-input
              id="input-9"
              v-model="sale.customerNumber"
              type="number"
              placeholder="Ingrese el teléfono del cliente"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="sale-input"
            label="Dirección del cliente:"
            label-for="input-10"
          >
            <b-form-input
              id="input-10"
              v-model="sale.customerAdress"
              type="text"
              placeholder="Ingrese el dirección del cliente"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="sale-input"
            label="Mail del cliente:"
            label-for="input-10"
          >
            <b-form-input
              id="input-10"
              v-model="sale.customerEmail"
              type="email"
              placeholder="Ingrese el correo electrónico del cliente"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="item-container"
            id="input-group-3"
            label="Mes de cumpleaños:"
            label-for="input-3"
          >
            <b-form-select
              id="input-3"
              v-model="sale.customerBirthday"
              :options="getMonths()"
            ></b-form-select>
          </b-form-group>

          <div class="custom-control custom-switch sale-input">
            <input
              v-model="hasToFinishSale"
              type="checkbox"
              class="custom-control-input"
              id="customSwitches"
            />
            <label class="custom-control-label" for="customSwitches"
              >Esta finalizada la venta?</label
            >
          </div>
        </div>
      </tab-content>
      <tab-content title="Pago">
        <v-container fluid>
          <v-layout wrap>
            <section
              :class="{
                selectedPaymentType: sale.paymentType === 'Efectivo',
                item: true,
              }"
              @click="selectPaymentType('Efectivo')"
            >
              <div class="image">
                <img src="../assets/Efectivo.svg" width="80px" height="80px" />
              </div>
              <h5 class="name">Efectivo</h5>
            </section>
            <section
              :class="{
                selectedPaymentType: sale.paymentType === 'Mercado Pago',
                item: true,
              }"
              @click="selectPaymentType('Mercado Pago')"
            >
              <div class="image">
                <img
                  src="../assets/MercadoPago.png"
                  width="80px"
                  height="80px"
                />
              </div>
              <h5 class="name">Mercado Pago</h5>
            </section>
            <section
              :class="{
                selectedPaymentType:
                  sale.paymentType === 'Transferencia Bancaria',
                item: true,
              }"
              @click="selectPaymentType('Transferencia Bancaria')"
            >
              <div class="image">
                <img src="../assets/Banco.svg" width="80px" height="80px" />
              </div>
              <h5 class="name">Transferencia Bancaria</h5>
            </section>
          </v-layout>
        </v-container>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import firebase from "firebase/firebase";
import { db } from "../firebase";
import checkout_mixins from "../mixins/checkout_mixins";
import user_detection from "../mixins/user_detection";
import Header from "../components/Header";

export default {
  mixins: [checkout_mixins, user_detection],
  name: "Checkout",
  firebase: {
    origins: db.ref("origins"),
    paymentTypes: db.ref("paymentTypes"),
    sales: db.ref("sales"),
    products: db.ref("products"),
    customers: db.ref("customers"),
  },
  data() {
    return {
      sale: {
        saleNumber: 0,
        origin: "Seleccione un origen",
        paymentType: "",
        products: [],
        status: "Para Entregar",
        isPayment: false,
        amountAditionals: 0,
        total: 0,
        customerName: "",
        customerNumber: "",
        customerAdress: "",
        customerEmail: "",
        customerBirthday: "Seleccione mes de cumpleaños",
        date: "",
        sellerUserName: "",
      },
      hasToFinishSale: false,
      origins: [],
      paymentTypes: [],
      sales: [],
      products: [],
      customers: [],
    };
  },
  mounted() {
    this.isUserAdmin();
  },
  computed: {},
  methods: {
    getMonths() {
      return [
        "Seleccione mes de cumpleaños",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
    },
    getOrigins() {
      var array = [];
      array.push("Seleccione un origen");
      for (var i = 0; i < this.origins.length; i++) {
        array.push(this.origins[i].name);
      }
      return array;
    },
    selectPaymentType(paymentType) {
      this.sale.paymentType = paymentType;
    },
    onComplete() {
      this.sale.date = this.getDateFormat();
      this.sale.saleNumber = this.sales.length + 1;
      this.sale.status = this.hasToFinishSale ? "Finalizada" : "Para Entregar";
      this.sale.isPayment = true;
      this.sale.amountAditionals = this.getShippingTotal;
      this.sale.total = this.getShoppingTotal;
      this.sale.products = this.getSelectedProds;

      if (this.validateInfo()) {
        this.sale.products.forEach((prod) => {
          let p = this.products.filter((t) => t.code === prod.code);
          if (p !== null && p !== undefined && p.length > 0) {
            prod.options.forEach((op) => {
              let o = p[0].options.filter((t) => t.name === op.name);
              if (o !== null && o !== undefined && o.length > 0) {
                let index = p[0].options.indexOf(o[0]);
                p[0].options[index].stock -= op.quantity;
              }
            });
            db.ref("products/" + p[0][".key"]).update(p[0]);
          }
        });

        db.ref("sales").push(this.sale);

        let cust = this.customers.filter(
          (t) => t.email === this.sale.customerEmail
        );
        if (cust !== null && cust !== undefined && cust.length > 0) {
          cust[0].name = this.sale.customerName;
          cust[0].phone = this.sale.customerNumber;
          cust[0].adress = this.sale.customerAdress;
          cust[0].birthday = this.sale.customerBirthday;
          if (cust[0].sales === undefined || cust[0].sales === null) {
            cust[0].sales = [];
          }
          cust[0].sales.push({ saleNumber: this.sale.saleNumber });

          db.ref("customers/" + cust[0][".key"]).update(cust[0]);
        } else {
          db.ref("customers").push({
            name: this.sale.customerName,
            phone: this.sale.customerNumber,
            adress: this.sale.customerAdress,
            email: this.sale.customerEmail,
            sales: [{ saleNumber: this.sale.saleNumber }],
          });
        }

        this.onReset();
        this.$router.replace("Home"); // FIXME::: Redirigir a una pagina de agradecimiento por la compra!
      }
    },
    validateInfo() {
      var msg = "";
      if (this.sale.products.length > 0) {
        if (this.sale.origin != "Seleccione un origen") {
          if (this.sale.paymentType != "") {
            return true;
          } else {
            msg = "Debe seleccionar un medio de pago";
          }
        } else {
          msg = "Debe seleccionar un origen";
        }
      } else {
        msg = "Debe agregar un producto a la venta";
      }
      alert(msg);
      return false;
    },
    getDateFormat() {
      var d = new Date();
      var datestring =
        d.getDate() +
        "/" +
        (d.getMonth() + 1) +
        "/" +
        d.getFullYear() +
        " - " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds();
      return datestring;
    },
    onReset(evt) {
      this.sale = {
        saleNumber: 0,
        origin: "Seleccione un origen",
        paymentType: "",
        products: [],
        status: "Para Entregar",
        isPayment: false,
        amountAditionals: 0,
        total: 0,
        customerName: "",
        customerNumber: "",
        customerAdress: "",
        customerEmail: "",
        customerBirthday: "Seleccione mes de cumpleaños",
        date: "",
        sellerUserName: "",
      };
      this.hasToFinishSale = false;
      this.$store.commit("SET_SELECTED_PRODUCTS", []);
      this.$store.commit("SET_TOTAL_SHIPPING", 0);
    },
  },
  components: {
    Header,
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.layout.wrap {
  place-content: center;
}
.item {
  border-bottom-style: solid;
  border-color: darkgray;
  border-width: thin;
  background-color: rgba(95, 106, 121, 0.06);
  margin: 3em;
  padding: 2em;
  border-radius: 15px;
  width: 280px;
  cursor: pointer;
}
.image {
  width: 100%;
  text-align: center;
}
.name {
  margin-top: 0.5em;
  text-align: center;
}
.selectedPaymentType {
  border-color: #009db0;
  border-style: solid;
  border-width: initial;
}
@media only screen and (max-width: 600px) {
  .item {
    margin: 1em;
    padding: 1em;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Checkout.vue